import React, {useState} from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
// import Accordion from 'react-bootstrap/Accordion';
import Select  from 'react-select';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { error_api_call } from '../../actions/action-creators/common';
import { alertResponseMessage } from '../../actions/action-creators/response';
import { RSstandardStyle } from '../../config/react-select';
import { CharacterCount } from "../form/count";
// import { LoaderMedium } from '../loader';
// import { EvaModal } from '../askeva/help-button';

function FormInput(props) {
    const [croppedImg, setCroppedImg] = useState(null);
    const cropperRef = React.createRef(null);
    const [previewDocData, setPreviewDoc] = useState([]);
    const onCrop = (field_name) => {
        const cropper = cropperRef.current?.cropper;
        // setCroppedImg(cropper.getCroppedCanvas().toDataURL());
        // cropper.getCroppedCanvas({
        //     fillColor: '#fff',
        //   }).toDataURL('image/jpeg');
        setCroppedImg(cropper.getCroppedCanvas({
            fillColor: '#fff',
          }).toDataURL('image/jpeg'));
        cropper.getCroppedCanvas({
            fillColor: '#fff',
          }).toBlob((blob) => {
            // setPreviewPicBlob(blob);
            props.updateInput('object', 'input-file', field_name, blob);
        }, 'image/jpeg');
    };
    const previewDoc = (event, form_type, file_type, field_name='') => {
        try{
            const files = event.target.files;
            if(files.length > 0){
                const uploadedImg = [];
                const documetAllowedExt = file_type === 'image' ?  ["png", "jpg", "jpeg"] : ["png", "jpg", "jpeg", "pdf"];
                const imageExt = ["image/png", "image/jpg", "image/jpeg"];
                const allowedSize = process.env.REACT_APP_UPLOAD_FILE_SIZE;//2MB-200000
                const allowedQty = form_type === 'Pic' ? 1 : process.env.REACT_APP_UPLOAD_FILE_QTY - previewDocData.length;
                if(allowedQty){
                    for(let i=0; i<files.length; i++){
                        const imgFile = files[i];
                        var ext = imgFile.name.slice((imgFile.name.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
                        //Check for file size and extension
                        // const size = Math.round((imgFile.size / 1024));
                        // console.log(size, 'size')
                        if(imgFile.size <= allowedSize && documetAllowedExt.includes(ext)){
                            const imgData = {data: imgFile,
                                            src: URL.createObjectURL(imgFile),
                                            title: imgFile.name,
                                            is_image: imageExt.includes(imgFile.type.toLowerCase()) ? true : false,
                                            ext
                                        };
                            uploadedImg.push(imgData);
                        }else{
                            alertResponseMessage({alert_type: 2,
                                                message: `${file_type === 'image'
                                                            ? `Photo/Image allowed size is ${process.env.REACT_APP_FILE_SIZE} and it must be an image.`
                                                            : `Image/Doc allowed size is ${process.env.REACT_APP_FILE_SIZE} and it must be an image/pdf.`
                                                }`});
                        }
                        // if(form_type !== 'Pic' && uploadedImg.length >= 2){
                        if(uploadedImg.length >= allowedQty){
                            break;
                        }
                    }
                }
                if(form_type === 'Pic'){
                    if(uploadedImg.length > 0){
                        props.updateInput('object', 'input-preview', field_name, {...uploadedImg[0]});
                    }else{
                        props.updateInput('object', 'input-preview', field_name, null);
                    }
                }else{
                    const attemptQty = previewDocData.length + files.length;
                    if(attemptQty > process.env.REACT_APP_UPLOAD_FILE_QTY){
                        alertResponseMessage({alert_type: 2,
                                            message: `Maximum 2 Images${file_type === 'image' ? '' : '/pdf'} Allowed`});
                    }
                    const newImgData = previewDocData.concat(uploadedImg);
                    setPreviewDoc([...newImgData]);
                    // if(newImgData.length > 0){
                    //     setBtnDisabled({...isBtnDisabled, [form_type]: false});
                    // }
                }
            }
        }catch(e){
            console.log(e)
            form_type === 'Pic'
                ? 
                    props.updateInput('object', 'input-preview', field_name, null)
                : setPreviewDoc([]);
            error_api_call({error: `portfolio|edit|previewDoc|${e}`});
        }
    }
    const formatOptionLabel = (e, payload) => {
        if(typeof payload !== "undefined"
            && payload.req === true
        ){
            var content = `<b>${e[payload.key]}</b><span class="hideSpan">: ${e[payload.subkey]}</span>`;
            if(typeof payload.examples !== "undefined"){
                content+= "</br>Example:<ul>";
                var exData = e[payload.examples];
                if(!Array.isArray(e[payload.examples])) {
                    exData = exData.split("|")
                }
                exData.forEach((ex, ex_index) => {
                    content+= `<li key="ex${ex_index}">${ex}</li>`;
                })
                content+= "</ul>";
            }
            return (
                <span dangerouslySetInnerHTML={{ __html: content }} />
                // <span><b>{e[payload.key]}</b><span className="hideSpan">: {e[payload.subkey]}</span></span>
            )
        }else{
            // ✅ fallback to default
            return e.label || e.value;
        }
    };
    //Filter Option
    const customFilter = (option, searchText, payload) => {
        if(typeof payload !== "undefined"
            && payload.req === true
        ){
            let exampleMatch = false;
            const keyMatch = option.data[payload.key]
                                ?.toString()
                                .toLowerCase()
                                .includes(searchText.toLowerCase());

            const subKeyMatch = option.data[payload.subkey]
                                ?.toString()
                                .toLowerCase()
                                .includes(searchText.toLowerCase());
            if(typeof option.data[payload.examples] !== "undefined"){
                if (Array.isArray(option.data[payload.examples])) {
                    exampleMatch = option.data[payload.examples].some(ex =>
                        ex.toString().toLowerCase().includes(searchText.toLowerCase())
                    );
                } else {
                    exampleMatch = option.data[payload.examples]
                        ?.toString()
                        .toLowerCase()
                        .includes(searchText.toLowerCase());
                }
            }

            return keyMatch || subKeyMatch || exampleMatch;
        }
        // ✅ fallback: filter by label (default react-select behavior)
        return option.label?.toLowerCase().includes(searchText.toLowerCase());
    }

    return (
      <> 
        <Col xs={12} md={props.colMd} className={`mod-form-input ${props.colMdCls||''}`}>
            <Form.Group className={`${props.formCls ? props.formCls : 'mb-4'}`}>
                <Form.Label htmlFor={props.name}>
                    <b dangerouslySetInnerHTML={ { __html: `${props.label}`}}></b>
                    {props.required && (<em className="required">*</em>)}
                    {props.tagline && <span className="fw-light" dangerouslySetInnerHTML={ { __html: `:${'&nbsp;'}${props.tagline}`}}></span>}
                </Form.Label>
                <div className="d-flex justify-content-between">
                <div className={props.widthCls ? props.widthCls: "w-100"}>
                {/* Input */}
                {(props.type === "number" 
                    || props.type === "text" 
                    || props.type === "email") 
                    ?
                        <>
                        <input
                            className="form-control"
                            id={props.name}
                            name={props.name}
                            // type="text"
                            type={props.type === "number" ? "text" : props.type} 
                            value={props.data?.[props.name]}
                            onChange={(e) => props.updateInput('object', 'input', props.name, e.target.value)}
                            placeholder={typeof props.placeholderData !== "undefined" && props.placeholderData.length > 0  ? `Eg.${props.placeholderData.length === 1 ? '' : ' 1'}: ${props.placeholderData[0]}` : props.placeholder}
                            readOnly={props.isProcess}
                        />
                        {props.count && (
                            <CharacterCount
                                max={props.count}
                                string={props.data?.[props.name]}
                            />
                        )}
                        </>
                    :
                        // Textarea
                        props.type === "textarea"
                        ?
                            <>
                            <textarea
                                className="form-control"
                                id={props.name}
                                name={props.name}
                                rows={props.rows}
                                value={props.data?.[props.name]}
                                onChange={(e) => props.updateInput('object', 'textarea', props.name, e.target.value)}
                                placeholder={typeof props.placeholderData !== "undefined" && props.placeholderData.length > 0  ? `Eg.${props.placeholderData.length === 1 ? '' : ' 1'}: ${props.placeholderData[0]}` : props.placeholder}
                                readOnly={props.isProcess}
                            />
                            {props.count && (
                                <CharacterCount
                                    max={props.count}
                                    string={props.data?.[props.name]}
                                />
                            )}
                            </>
                        :
                            props.type === "date"
                            ?
                            <div>
                                <input type="date" className="form-control w-150p p-1" name={props.name} value={props.data?.[props.name]} onChange={(e) => props.updateInput('object','input', props.name, e.target.value)} min={props.min ? props.min : "1922-12-31"} readOnly={props.isProcess} max={(typeof props.max !== "undefined" && props.max === "") ? ""  : moment(new Date()).format("YYYY-MM-DD")}/>
                            </div>
                            :
                                props.type === "multi-select"
                                ?
                                <div className={"w-100"}>
                                    <Select
                                        closeMenuOnSelect={false}
                                        id={props.name}
                                        options={props.selectOptions?.data} 
                                        defaultValue={props.data?.[props.name]}
                                        value={props.data?.[props.name]}
                                        placeholder={props.placeholder ? props.placeholder : ((props.placeholderData && props.placeholderData.length > 0) ? `Eg. 1: ${props.placeholderData[0]}`: '')}
                                        onChange={(value) => props.updateInput('object', 'select-multi', props.name, value)}
                                        getOptionLabel ={(option) => option[props.selectOptions?.label]}
                                        getOptionValue ={(option) => option[props.selectOptions?.value]}
                                        // menuPlacement="auto"
                                        menuPosition={'fixed'}
                                        styles={RSstandardStyle}
                                        // isDisabled ={true}
                                        formatOptionLabel={
                                            props.selectOptions?.format
                                            ? (e) => formatOptionLabel(e, props.selectOptions?.format)
                                            : undefined
                                        }
                                        // menuIsOpen={true} 
                                        classNamePrefix="reactCSel"
                                        isOptionDisabled={() => (props.data?.[props.name] && props.data?.[props.name].length) >= props.selectOptions.max}
                                        isSearchable={true}
                                        filterOption={
                                            props.selectOptions?.format
                                            ? (option, searchtext) => customFilter(option, searchtext, props.selectOptions?.format)
                                            : undefined
                                        }
                                        // components={{ValueContainer: (e) => selectComponent(e, props.selectOptions.format.key)}}
                                        // isOptionDisabled={() => props.data?.[props.name]?.length > props.selectOptions?.max}
                                        // selectionLimit={2}
                                        isMulti
                                        isDisabled={props.isProcess}
                                    />
                                </div>
                                :
                                    props.type === "select"
                                    ?
                                    <div className={"w-100"}>
                                        <Select
                                            // closeMenuOnSelect={false}
                                            id={props.name}
                                            options={props.selectOptions?.data} 
                                            defaultValue={props.data?.[props.name]}
                                            value={props.data?.[props.name]}
                                            placeholder={typeof props.placeholderData === "undefined"
                                            ? ''
                                                : props.placeholderData.length > 1
                                                    ? `Eg. 1: ${props.placeholderData[0]}`
                                                    : props.placeholderData.length > 0
                                                        ? `${props.placeholderData[0]}`
                                                        : ''}
                                            onChange={(value) => props.updateInput('object', 'select-react', props.name, value)}
                                            getOptionLabel ={(option) => option[props.selectOptions?.label]}
                                            getOptionValue ={(option) => option[props.selectOptions?.value]}
                                            // menuPlacement="auto"
                                            menuPosition={'fixed'}
                                            styles={RSstandardStyle}
                                            isDisabled={props.isProcess}
                                            // isDisabled ={true}
                                            // formatOptionLabel={(e) => formatOptionLabel(e, props.selectOptions.format)}
                                            // classNamePrefix="reactCSel"
                                            // isOptionDisabled={() => (props.data?.[props.name] && props.data?.[props.name].length) >= props.selectOptions.max}
                                            // isSearchable={true}
                                            // filterOption={(option, searchtext) => customFilter(option, searchtext, props.selectOptions.format)}
                                            // components={{ValueContainer: (e) => selectComponent(e, props.selectOptions.format.key)}}
                                            // isOptionDisabled={() => props.data?.[props.name]?.length > props.selectOptions?.max}
                                            // selectionLimit={2}
                                            // isMulti
                                        />
                                    </div>
                                    :
                                        props.type === "checkbox"
                                        ?
                                            <>
                                            <input className="form-check-input" type="checkbox" id={`ch_${props.name}`} value={props.data?.[props.name]} checked={props.data?.[props.name]} onChange={(e) => props.updateInput('object', 'checkbox', props.name, e.target.checked)} />
                                            <label className="form-check-label" htmlFor={`ch_${props.name}`}>&nbsp;{props.ch_label}</label>
                                            </>
                                        :
                                            props.type === "image-upload"
                                            ?
                                            <>
                                            <div className="mt-3">
                                            {props[props.name+'_preview'] &&
                                                <>
                                                <div className="d-flex">
                                                <Cropper
                                                    src={props[props.name+'_preview'].src}
                                                    style={{ height: 200, width: 200 }}
                                                    initialAspectRatio={1 / 1}
                                                    aspectRatio={1/1}
                                                    guides={false}
                                                    crop={() => onCrop(props.name)}
                                                    ref={cropperRef}
                                                    dragMode="move"
                                                    // cropBoxResizable={false}
                                                    background={false}
                                                    // minContainerWidth={"100%"}
                                                    minContainerWidth={200}
                                                    zoomable={false}
                                                    highlight={false}
                                                    checkOrientation={false}
                                                    // getCroppedCanvas={{fillcolor: "#FFFFFF"}}
                                                />
                                                <div className="d-none d-sm-flex ms-4">
                                                    <img src={croppedImg} className="img-thumbnail cropper-preview-img" alt={"Opp. Logo"} />
                                                </div>
                                                </div>
                                                </>
                                            }
                                            <div className="upload-img text-center mt-3">
                                                <div className="m-3">
                                                    {!props[props.name+'_preview'] && props.data[props.name] &&
                                                        <img src={props.data[props.name]} alt={"profile_log"} className="img-thumbnail cropper-preview-img" />
                                                    }
                                                </div>
                                                <div className="btn btn-light btn-outline-primary btn-sm">
                                                    <span>{props?.btn_text ? props.btn_text : 'Upload photo/logo'}</span>
                                                    <input type="file" className="logo-input" name="profile_log" onChange={(e) => previewDoc(e,'Pic', 'image', props.name+'_preview')} accept="image/x-png,image/jpg,image/jpeg" />
                                                </div>
                                            </div>
                                            </div>
                                            </>
                                            :
                                                props.type === "radio"
                                                ?
                                                <div className="mt-3">
                                                    {props?.radioOptions?.data.map((radio, rad_indx) => (
                                                        <label className="me-3" key={`${props.name}_${rad_indx}`}>
                                                        <input
                                                            className="form-check-input"
                                                            // id={props.name}
                                                            name={props.name}
                                                            type="radio"
                                                            value={radio[props?.radioOptions?.value]}
                                                            // value={props.data?.[props.name]}
                                                            checked={props.data?.[props.name] === radio[props?.radioOptions?.value]}
                                                            onChange={(e) => props.updateInput('object', 'radio', props.name, radio[props?.radioOptions?.value])}
                                                            // onChange={(e) => props.updateInput('object', 'radio', props.name, e.target.value)}
                                                            disabled={props.isProcess}
                                                        />
                                                        &nbsp;{radio[props?.radioOptions?.label]}
                                                        </label>
                                                    ))}
                                                </div>
                                                :
                                                <></>
                }
                </div>
                {/* {props?.showEva && (
                    <button
                        className="align-items-center btn btn-primary chat-post justify-content-center ms-1 ms-md-3 text-center d-inline-flex"
                        type="submit"
                        disabled={props?.askEvaLoader ? true : false}
                        onClick={(e) => props.openAskEva(e)}
                    >
                        {props?.askEvaLoader
                        ?
                            <LoaderMedium size={24}/>
                        :
                            <EvaModal />
                        }
                        <span className="ms-2">&nbsp;Ask EVA</span>
                    </button>
                )} */}
                </div>
                {props.placeholderData && (
                    <>
                    {((props.type === "radio" && props.placeholderData.length > 0)
                        || props.placeholderData.length > 1
                    )
                        ?
                        <div className="fs-12p fst-italic mt-1 text-black-50">
                            {props.placeholderData.map((p_data, p_index) => (
                                <span key={`place_hold${p_index}`}>
                                {(props.type === "radio" || p_index !== 0) && (
                                    <span dangerouslySetInnerHTML={ { __html: `<b>Eg. ${p_index+1}</b>: ${p_data} ${p_index+1 !== props.placeholderData.length && (', ')}`}}>
                                        {/* <b>Eg. {p_index+1}</b>: {p_data} {p_index+1 !== props.placeholderData.length && (', ')} */}
                                    </span>
                                )}
                                </span>
                            ))}
                        </div>
                        : (props.placeholderData.length === 1
                            && (props.type === "year_to_from" 
                                || props.type === "month_year_from"
                                || props.type === "month"))
                            ?
                            <div className="fs-12p fst-italic mt-1 text-black-50">
                                <span><b>Eg.</b>: {props.placeholderData[0]}</span>
                            </div>
                            : <></>
                    }
                    </>
                )}
            </Form.Group>
        </Col>
      </>
    );
}
  
export default FormInput;